import SingleStackTag, { DefaultStackIcon } from './SingleStackTag';

export default SingleStackTag;
export { DefaultStackIcon };
